/**
 *
 * Asynchronously loads the component for StaffSummary
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const StaffSummary = lazyLoad(
  () => import('./index'),
  module => module.StaffSummary,
);
